const PREFIX = "receiving_wizard_reservation_plan_";

function keyFor(shipmentId) {
  return `${PREFIX}${shipmentId}`;
}

export function loadReservationPlan(shipmentId) {
  try {
    const value = sessionStorage.getItem(keyFor(shipmentId));
    return value ? JSON.parse(value) : null;
  } catch (_error) {
    return null;
  }
}

export function saveReservationPlan(shipmentId, plan) {
  try {
    sessionStorage.setItem(keyFor(shipmentId), JSON.stringify(plan));
  } catch (_error) {
    // Ignore session storage failures and keep the wizard usable.
  }
}

export function clearReservationPlan(shipmentId) {
  try {
    sessionStorage.removeItem(keyFor(shipmentId));
  } catch (_error) {
    // Ignore session storage failures and keep the wizard usable.
  }
}
